// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vwsNVF2xqzooKKBWvydF{flex-direction:column;flex:auto;min-height:0;margin:0 16px;padding-top:12px;display:flex}.nQ7Jskiz5gQDwcobvCO8{padding:8px 4px 2px}.lwBDVPght3cyei_DWXPl{padding-left:0}.Us8BlXrfQHnjKuGi7R80{align-items:center;gap:4px;min-width:0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `vwsNVF2xqzooKKBWvydF`,
	"searchWrap": `nQ7Jskiz5gQDwcobvCO8`,
	"search": `lwBDVPght3cyei_DWXPl`,
	"typeCell": `Us8BlXrfQHnjKuGi7R80`
};
export default ___CSS_LOADER_EXPORT___;
